// src/components/TestimonialSection.jsx
import { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import WOW from "wowjs";
import { FaStar, FaStarHalfAlt } from "react-icons/fa";

const testimonials = [
  {
    text: "Design24 đã biến ý tưởng của chúng tôi thành một sản phẩm tuyệt vời. Cách tiếp cận sáng tạo và sự tận tâm trong từng chi tiết thật sự ấn.",
    name: "Lê Ngọc Minh Anh",
    role: "Chuyên viên Marketing",
    img: "av2.webp",
  },
  {
    text: "Làm việc với Design24 là một trải nghiệm tuyệt vời. Đội ngũ luôn chủ động, sáng tạo và mang đến giải pháp vượt ngoài mong đợi.",
    name: "Trần Quang Huy",
    role: "Thiết kế Web",
    img: "av1.webp",
  },
  {
    text: "Nhờ sự đồng hành của Design24, thương hiệu của chúng tôi đã có bước tiến mới trong việc xây dựng hình ảnh và tiếp cận khách hàng.",
    name: "Phạm Thu Hà",
    role: "Giám đốc Kinh doanh",
    img: "av2.webp",
  },
  {
    text: "Đội ngũ Design24 làm việc rất chuyên nghiệp, luôn nắm bắt đúng nhu cầu và đưa ra giải pháp phù hợp cho doanh nghiệp của chúng tôi.",
    name: "Lý Văn Nam",
    role: "Doanh nhân",
    img: "av1.webp",
  },
];

const TestimonialSection = () => {
  useEffect(() => {
    if (typeof WOW === "function") new WOW.WOW().init();
  }, []);

  const renderStars = () => (
    <>
      {[...Array(4)].map((_, i) => (
        <FaStar key={i} />
      ))}
      <FaStarHalfAlt />
    </>
  );

  return (
    <section className="testimonial-section fix section-padding section-bg">
      <div className="container">
        <div className="tesimonial-wrapper-2">
          <div className="row g-4">
            <div className="col-lg-5">
              <div className="testimonial-image">
                <img
                  src="/assets/img/testimonial/testimonial.webp"
                  alt="testimonial"
                />
              </div>
            </div>
            <div className="col-lg-5">
              <div className="testimonial-content">
                <div className="section-title">
                  <h6 className="wow fadeInUp">Khách hàng nói gì</h6>
                  <h2
                    className="wow fadeInUp"
                    data-wow-delay=".3s"
                  >
                    <span>Phản hồi</span> từ khách hàng
                  </h2>
                </div>
                <p
                  className="mt-3 mt-md-0 wow fadeInUp"
                  data-wow-delay=".5s"
                >
                  Từ ý tưởng đến triển khai, Design24 luôn làm chủ từng chi tiết
                  trong chiến dịch. Sự sáng tạo và chuyên môn của họ đã đưa
                  thương hiệu chúng tôi lên một tầm cao mới.
                </p>
              </div>
            </div>
          </div>

          <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={30}
            slidesPerView={2}
            loop={true}
            pagination={{ clickable: true }}
            speed={800}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            breakpoints={{
              0: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              1200: { slidesPerView: 3 },
            }}
            className="testimonial-slider-2"
          >
            {testimonials.map((t, i) => (
              <SwiperSlide key={i}>
                <div className="testimonial-card-items">
                  <div className="testi-top">
                    <div className="star">{renderStars()}</div>
                    <div className="quote-icon">
                      <img
                        src="/assets/img/testimonial/quote.png"
                        alt="quote"
                      />
                    </div>
                  </div>
                  <p>{t.text}</p>
                  <div className="client-info">
                    <div className="client-img">
                      <img
                        className="rounded"
                        src={`/assets/img/testimonial/${t.img}`}
                        alt={t.name}
                      />
                    </div>
                    <div className="content">
                      <h5>{t.name}</h5>
                      <span>{t.role}</span>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
